// src/pages/Appli/AppliAdmin/users-admin/data/usersAdmin.data.js

export const PAGE_SIZE = 20;

export const BADGE_THUMB = "/img/luttecontrelesderives.png";

export const ROLES_IN_CLUB = [
  "Dirigeant(e)",
  "Enseignant(e)",
  "Coach",
  "Arbitre",
  "Judoka(te) licencié(e) au club",
];

export const ROLE_OPTIONS = [
  {
    id: "",
    label: "Tous les rôles",
  },
  {
    id: "1",
    label: "Administrateur",
  },
  {
    id: "2",
    label: "Utilisateur",
  },
  {
    id: "3",
    label: "Dirigeant Club",
  },
  {
    id: "4",
    label: "Arbitrage",
  },
  {
    id: "5",
    label: "Responsable Arbitrage",
  },
  {
    id: "6",
    label: "Membre Ligue",
  },
  {
    id: "7",
    label: "Responsable Comité",
  },
  {
    id: "8",
    label: "Enseignant-Coach",
  },
];

export const ROLE_META = {
  1: {
    name: "Administrateur",
    className:
      "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
  },

  2: {
    name: "Utilisateur",
    className:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
  },

  3: {
    name: "Dirigeant Club",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  },

  4: {
    name: "Arbitrage",
    className:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
  },

  5: {
    name: "Responsable Arbitrage",
    className:
      "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-500/20 dark:bg-violet-500/10 dark:text-violet-300",
  },

  6: {
    name: "Membre Ligue",
    className:
      "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300",
  },

  7: {
    name: "Responsable Comité",
    className:
      "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200",
  },

  8: {
    name: "Enseignant-Coach",
    className:
      "border-pink-200 bg-pink-50 text-pink-700 dark:border-pink-500/20 dark:bg-pink-500/10 dark:text-pink-300",
  },
};

export const DEFAULT_ROLE_META = {
  name: "Non affecté",
  className:
    "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200",
};